import React from 'react'
import styled from 'styled-components'
import { Flex } from 'reflexbox'

const InnerContainerLogin = styled(Flex)`
  overflow-y: auto;
  overflow-x: auto;
  background: var(--card-bg);
  box-shadow: 0px 2px 14px 2px var(--shadow-color);
  border-radius: 8px;
  padding: 12px 8px;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: stretch;
  transition: background 0.3s ease, box-shadow 0.3s ease;
`

const LoginContainer = props => {
    return (
      <InnerContainerLogin style={{margin: 'auto 16px'}}>
        {props.children}
      </InnerContainerLogin>
    )
}

export default LoginContainer